import {useCallback} from 'react';

import {isString} from 'ramda-adjunct';

import {vehiclesRoutes} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['vehicleId'] as const;

export function InspectionOverview() {
  const navigateTo = useNavigate();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = useCallback(
    ({actionKey, rowId, getColumnData}) => {
      if (!isString(rowId)) {
        return;
      }

      switch (actionKey) {
        case 'detail':
          navigateTo(
            composePath(vehiclesRoutes.inspectionDetail, {
              params: {
                id: getColumnData<string>('vehicleId')?.value as string,
                inspectionId: rowId,
              },
            })
          );
          break;
        default:
          // TODO: Create warn utils T20-17310
          console.warn(`Action callback was not specified for action ${actionKey}`);
          break;
      }
    },
    [navigateTo]
  );

  return (
    <DmsDataGrid
      data-testid="inspection"
      gridCode="inspection"
      actionCallback={actionCallback}
      predefinedColumns={PREDEFINED_COLUMNS}
    />
  );
}
